import { Driver, Vehicle } from "./client";


export class QuoteBase {
    quoteId: number;
    sellerId: number;
    clientId: number;
    incidentId: number;
    statusId: number;
    incidentStatusId: number;
    stockChecked: Date
}

export class Quote extends QuoteBase {    
    dtCreated: string;
    quoteOptions: QuoteOption[];
    quoteNumber: string;
    quoteRevision: number;
    incidentDistance: number;
    revisedToQuoteId: number;
    basedOnQuoteId: number;
}

export class QuoteSummary extends QuoteBase {   
    quoteOptions: QuoteOptionSummary[];
}

export class QuoteOptionSummary {
    quoteId: number;
    optionNumber: number;
    name: string;
    total: number;
    totalIncl: number;
    tyreName: string;
    tyreSoh: number;
}

export class QuoteOption extends QuoteOptionSummary {    
    quoteLines: QuoteLine[];
}

export class QuoteLine {
    quoteId: number;
    quoteOptionId: number;
    msfId: number;
    stockCustomId: number;
    description: string;
    stockCode: string;
    qty: number;
    price: number;
    cost: number;
}

export class QuoteDetail extends Quote {
    clientName: string;
    sellerName: string;
    incidentAddress: string
    incidentVehicle: Vehicle;
    driver: Driver;

}